import ThisModule from "./PageSafeguardingPolicy";

export default ThisModule;
